export type LogLevel = "silent" | "error" | "warn" | "info" | "debug";

function getAppEnv(): string {
  const fromDefine: string = typeof __APP_ENV__ !== "undefined" ? __APP_ENV__ : "production";

  const fromProcess =
    typeof process !== "undefined" && (process as any).env
      ? (process as any).env.REACT_APP_ENV ||
        (process as any).env.APP_ENV ||
        (process as any).env.NODE_ENV
      : undefined;

  return fromDefine || fromProcess || "production";
}

const APP_ENV = getAppEnv();

// si quieres mantener la lógica anterior:
const IS_DEV_OR_QA_OR_TEST = /^(dev|development|qa|test)$/i.test(APP_ENV);
const IS_JEST = typeof process !== "undefined" && !!(process as any).env?.JEST_WORKER_ID;

const DEFAULT_LEVEL: LogLevel = IS_DEV_OR_QA_OR_TEST || IS_JEST ? "debug" : "silent";

const LEVELS: Record<LogLevel, number> = { silent: -1, error: 0, warn: 1, info: 2, debug: 3 };

const LS_KEY = "log:level";
const stored =
  typeof window !== "undefined" ? (localStorage.getItem(LS_KEY) as LogLevel | null) : null;

let level: LogLevel = stored ?? DEFAULT_LEVEL;
let currentLevel = LEVELS[level];

export function setLevel(newLevel: LogLevel) {
  level = newLevel;
  currentLevel = LEVELS[newLevel];
  if (typeof window !== "undefined") localStorage.setItem(LS_KEY, newLevel);
}

function canLog(l: Exclude<LogLevel, "silent">) {
  return currentLevel >= 0 && LEVELS[l] <= currentLevel && (IS_DEV_OR_QA_OR_TEST || IS_JEST);
}

export const logger = {
  setLevel,
  getLevel(): LogLevel {
    return level;
  },
  error: (...a: any[]) => {
    if (canLog("error")) console.error(...a);
  },
  warn: (...a: any[]) => {
    if (canLog("warn")) console.warn(...a);
  },
  info: (...a: any[]) => {
    if (canLog("info")) console.info(...a);
  },
  debug: (...a: any[]) => {
    if (canLog("debug")) console.debug(...a);
  },
  time: (l: string) => {
    if (canLog("debug")) console.time(l);
  },
  timeEnd: (l: string) => {
    if (canLog("debug")) console.timeEnd(l);
  },
  group: (l: string) => {
    if (canLog("debug")) console.group(l);
  },
  groupEnd: () => {
    if (canLog("debug")) console.groupEnd();
  },
};
